import React, { useRef, useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import { db } from "../firebase";
import { addDoc, collection } from "firebase/firestore";
import Alert from "react-bootstrap/Alert";
import seoData from "../seoData/Consultancy.json";

// Firebase Storage isn't available on this project's billing plan, so the
// resume is embedded directly in the Firestore document instead. Firestore
// caps a document at 1MB total, and base64 inflates a file by ~33%, so the
// raw file is capped well below that to leave headroom for the other fields.
const MAX_RESUME_BYTES = 700 * 1024;

const Consultancy = () => {
  const form = useRef();
  const form2 = useRef();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    resume: "",
    resumeFileName: "",
    resumeFileType: "",
  });
  const [formData2, setFormData2] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });
  const [result, showresult] = useState(false);
  const [result2, showresult2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [obj, setObj] = useState();
  const [uploadError, setUploadError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [mobileError2, setMobileError2] = useState("");

  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
    setFormData((prev) => ({ ...prev, mobile: val }));
    if (val && val.length !== 10) {
      setMobileError("Contact number must be exactly 10 digits.");
    } else {
      setMobileError("");
    }
  };

  const handleMobileChange2 = (e) => {
    const val = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
    setFormData2((prev) => ({ ...prev, mobile: val }));
    if (val && val.length !== 10) {
      setMobileError2("Contact number must be exactly 10 digits.");
    } else {
      setMobileError2("");
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (formData.mobile.length !== 10) {
      setMobileError("Please enter a valid 10-digit contact number.");
      return;
    }

    const ref = collection(db, "consultancy");
    await addDoc(ref, {
      ...formData,
    });
    setFormData({
      name: "",
      mobile: "",
      email: "",
      resume: "",
      resumeFileName: "",
      resumeFileType: "",
    });
    setObj();
    setUploadError("");
    setMobileError("");
    showresult(true);

    setTimeout(() => {
      showresult(false);
    }, 10000);

  };
  const sendEmail2 = async (e) => {
    e.preventDefault();
    if (formData2.mobile.length !== 10) {
      setMobileError2("Please enter a valid 10-digit contact number.");
      return;
    }

    const ref = collection(db, "consultancyMessage");
    await addDoc(ref, {
      ...formData2,
    });
    setFormData2({
      name: "",
      mobile: "",
      email: "",
      message: "",
    });
    setMobileError2("");
    showresult2(true);
    setTimeout(() => {
      showresult2(false);
    }, 10000);

  };


  const uploadResume = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_RESUME_BYTES) {
      setUploadError(
        `"${file.name}" is ${(file.size / 1024).toFixed(0)}KB, which is over the ${(MAX_RESUME_BYTES / 1024).toFixed(0)}KB limit. Please attach a smaller file (a plain PDF or DOCX export usually fits).`
      );
      e.target.value = "";
      setObj();
      setFormData((prev) => ({ ...prev, resume: "", resumeFileName: "", resumeFileType: "" }));
      return;
    }

    setLoading(true);
    setUploadError("");

    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prev) => ({
        ...prev,
        resume: reader.result, // data URI: "data:<mime>;base64,...."
        resumeFileName: file.name,
        resumeFileType: file.type,
      }));
      setObj(file.name);
      setLoading(false);
    };
    reader.onerror = () => {
      console.error("File read error:", reader.error);
      setLoading(false);
      setUploadError("Couldn't read that file. Please try again.");
      e.target.value = "";
    };
    reader.readAsDataURL(file);
  };

  const Result = () => {
    return (
      <Alert variant="success" className="success-msg">
        Your Message has been successfully sent.
      </Alert>
    );
  };
  const Result2 = () => {
    return (
      <Alert variant="success" className="success-msg">
        Your Message has been successfully sent.
      </Alert>
    );
  };

  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Consultancy" page="Consultancy" />

        <div className="section section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-10">
                <h2 className="mb-3">Technical consultancy and dedicated resources</h2>
                <p>
                  Our consultancy work covers two related but distinct needs:
                  helping a client work through the technical side of an idea
                  before committing budget to it, and staffing an existing
                  project with qualified, dedicated resources on demand. Many
                  clients come to us with one and end up using both, but we
                  scope and price them separately so you're only paying for
                  what you actually need.
                </p>

                <h3 className="mt--40 mb-2">Technical and strategic guidance</h3>
                <p>
                  A lot of clients arrive with a real idea and a real budget
                  but not the technical background to know what's actually
                  involved in building it — which platform fits, what the
                  realistic timeline looks like, where the expensive parts
                  are hiding. Skipping this step is one of the most common
                  reasons a project either stalls or costs significantly more
                  than expected once development starts. We work through
                  those decisions with you before any code gets written, so
                  the plan you commit to is grounded in a realistic
                  understanding of the technology, not just the pitch.
                </p>

                <h3 className="mt--40 mb-2">Dedicated resources on demand</h3>
                <p>
                  When a project needs additional hands rather than a
                  strategy conversation, we provide dedicated developers and
                  testers who work directly with your team on a Contract-to-Hire
                  basis. Every resource goes through a screening and interview
                  process before being presented, and is available to start
                  on a remote engagement quickly rather than after a lengthy
                  onboarding cycle. We also have resources holding H1B visa
                  status available for on-site or remote roles serving the
                  USA specifically.
                </p>

                <h3 className="mt--40 mb-2">How an engagement typically starts</h3>
                <p>
                  Most engagements start with a short conversation about
                  what you're actually trying to solve — a technical
                  question, a staffing gap, or both — followed by a specific
                  recommendation rather than a generic pitch. If you're
                  confused about the technical side of an idea, or you have
                  the idea and the desire but not the roadmap, that
                  conversation is exactly where a consultancy engagement
                  starts. Feel free to <a href={process.env.PUBLIC_URL + "/contact"}>contact us</a> or
                  visit one of our offices — we'll walk you through examples
                  and live projects. Or fill in the form below and we'll get
                  back to you within 24 hours.
                </p>

                <h3 className="mt--40 mb-2">What a typical consultation covers</h3>
                <p>
                  The specifics change from client to client, but most
                  technical-guidance conversations end up touching the same
                  core questions: which platform or framework actually fits
                  the problem (rather than whichever one is trending), what a
                  realistic build timeline looks like once the real
                  requirements are on the table, where the costly or
                  high-risk parts of the build are likely to be, and whether
                  the idea needs to be built from scratch or can be assembled
                  faster from existing tools and services. A worked example:
                  a client comes to us with an idea for an internal tool that
                  needs to talk to three other systems they already run — we
                  map out which of those integrations are straightforward,
                  which ones are the actual risk, and price and phase the
                  build around that risk rather than treating every
                  integration as equal effort.
                </p>

                <h3 className="mt--40 mb-2">Common questions</h3>
                <p>
                  <strong>Do I need a finished spec before we talk?</strong>{" "}
                  No — most clients arrive with a rough idea, not a finished
                  spec. Part of the consultation is turning that rough idea
                  into something specific enough to price and build.
                </p>
                <p>
                  <strong>Can dedicated resources start quickly?</strong>{" "}
                  Usually yes. Because our developers and testers are already
                  screened, a typical placement moves faster than running a
                  hiring process from scratch — see{" "}
                  <a href={process.env.PUBLIC_URL + "/Staff-Augmentation"}>staff augmentation</a>{" "}
                  for how that works in more detail.
                </p>
                <p>
                  <strong>What if we're not sure whether we need advice or
                  staff?</strong>{" "}
                  That's exactly what the initial conversation is for — tell
                  us the problem, not the solution you think you need, and
                  we'll tell you honestly which one actually applies.
                </p>
                <p>
                  <strong>Is there a minimum engagement length?</strong>{" "}
                  No fixed minimum. A technical-guidance conversation can be
                  a single session; a dedicated-resources placement can run
                  from a few weeks to an ongoing arrangement, depending on
                  what the work actually needs.
                </p>
              </div>
            </div>
          </div>
          <ul className="list-unstyled shape-group-12">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="Circle"
              />
            </li>
          </ul>
        </div>

        <div className="bg-white">
          <div className="container">
            <div className="row pb-5">
              <div className="col-lg-6 mx-auto">
                <div className="contact-form-box shadow-box mb--100">
                  <form
                    className="axil-contact-form"
                    ref={form2}
                    onSubmit={sendEmail2}
                  >
                    <p className="text-center">Looking for consultation for your business, fill-in this form :</p>
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="contact-name"
                        required
                        value={formData2.name}
                        onChange={(e) => {
                          setFormData2({ ...formData2, name: e.target.value });
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="contact-email"
                        required
                        value={formData2.email}
                        onChange={(e) => {
                          setFormData2({ ...formData2, email: e.target.value });
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Contact No.</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="contact-phone"
                        required
                        maxLength={10}
                        placeholder="Enter 10-digit contact number"
                        value={formData2.mobile}
                        onChange={handleMobileChange2}
                      />
                      {mobileError2 && <div className="text-danger small mt-1">{mobileError2}</div>}
                    </div>
                    <div className="form-group mb--40">
                      <label>How can we help you?</label>
                      <textarea
                        className="form-control"
                        name="contact-message"
                        rows="4"
                        value={formData2.message}
                        onChange={(e) => {
                          setFormData2({ ...formData2, message: e.target.value });
                        }}
                      ></textarea>
                    </div>
                    <p className="small text-muted mb-3">
                      By submitting, you agree to our{" "}
                      <a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a>.
                    </p>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="axil-btn btn-fill-primary btn-fluid btn-primary"
                        name="submit-btn"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="form-group">
                      {result2 ? <Result2 /> : null}
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-6 mx-auto">
                <div className="contact-form-box shadow-box mb--100">
                  <form
                    className="axil-contact-form"
                    ref={form}
                    onSubmit={sendEmail}
                  >
                    <p className="text-center">Looking for remote positions, fill-in this form :</p>
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="contact-name"
                        required
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({ ...formData, name: e.target.value });
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="contact-email"
                        required
                        value={formData.email}
                        onChange={(e) => {
                          setFormData({ ...formData, email: e.target.value });
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Contact No.</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="contact-phone"
                        required
                        maxLength={10}
                        placeholder="Enter 10-digit contact number"
                        value={formData.mobile}
                        onChange={handleMobileChange}
                      />
                      {mobileError && <div className="text-danger small mt-1">{mobileError}</div>}
                    </div>
                    <div className="form-group mb--40">
                      <label>Drop your CV <span className="text-muted small">(PDF/DOCX, max 700KB)</span></label>
                      <div className="fileUpload">
                        <input
                          type="file"
                          className="form-control fileUpload-inp"
                          name="contact-file"
                          accept=".pdf,.doc,.docx"
                          onChange={(e) => uploadResume(e)}
                        />
                        <div className="fileUpload-mes">
                          Drag & Drop Files Here
                          <span>&nbsp;Browse Files</span>
                        </div>
                      </div>
                      {obj && <p className="text-success mt-2">{obj} file uploaded</p>}
                      {uploadError && <Alert variant="danger" className="mt-2">{uploadError}</Alert>}
                    </div>
                    <p className="small text-muted mb-3">
                      By submitting, you agree to our{" "}
                      <a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a>.
                    </p>
                    <div className="form-group">
                      <br className="d-none d-lg-block" />
                      <br className="d-none d-lg-block" />
                      <br />
                      <button
                        type="submit"
                        className="axil-btn btn-fill-primary btn-fluid btn-primary"
                        name="submit-btn"
                        disabled={loading}
                      >
                        {loading ? "Please wait..." : "Submit"}
                      </button>
                    </div>
                    <div className="form-group">
                      {result ? <Result /> : null}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default Consultancy;
